import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { StatisticaComponent } from '../../components/statistica/statistica.component';
import { CardModule } from 'src/app/theme/shared/components/card/card.module';
import { CustomIconsModule } from 'src/app/theme/shared/components/custom-icons/custom-icons.module';
import { InteractionListItemModule } from 'src/app/components/interactions/interaction-list-item/interaction-list-item.module';


@NgModule({
  declarations: [DashboardComponent, StatisticaComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    CardModule,
    CustomIconsModule,
    InteractionListItemModule
  ]
})
export class DashboardModule { }
